import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-textbox-label"
}
const _hoisted_2 = {
  key: 0,
  class: "c-textbox-label-required"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "c-suggestion-header" }, "Password must contain:", -1)
const _hoisted_4 = { class: "c-suggestion-list" }
const _hoisted_5 = { class: "c-textbox-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-textbox c-textbox-password", {
      'is-invalid': _ctx.errorMessage
    }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required && !_ctx.data)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Password, {
      ref: "textboxPassword",
      modelValue: _ctx.data,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data) = $event)),
      "toggle-mask": _ctx.toggleMask,
      disabled: _ctx.disabled,
      feedback: _ctx.feedback,
      placeholder: _ctx.placeholder,
      readonly: _ctx.readonly,
      autofocus: _ctx.autofocus,
      "strong-regex": _ctx.strongPasswordRegEx,
      onInput: _ctx.onInput
    }, _createSlots({ _: 2 }, [
      (_ctx.feedback)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-valid': _ctx.hasEightCharacters })
                }, " At least 8 characters ", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-valid': _ctx.hasLowerCase })
                }, "At least one lowercase", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-valid': _ctx.hasUpperCase })
                }, "At least one uppercase", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-valid': _ctx.hasNumeric })
                }, "At least one numeric", 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ 'is-valid': _ctx.hasSymbol })
                }, "At least one symbol", 2)
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "toggle-mask", "disabled", "feedback", "placeholder", "readonly", "autofocus", "strong-regex", "onInput"]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1)
  ], 2))
}